/* cc-footer — mobile footer-menu accordion (Empire parity, Tony
   2026-07-14). Empire collapsed menu columns behind their titles on
   small screens (has-accordion + chevron); Dawn stacks them open.
   Progressive enhancement: below 750px the menu-column headings become
   toggles; desktop is untouched. No observers — matchMedia + click. */

(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  const blocks = Array.from(document.querySelectorAll('.footer-block--menu'));
  if (!blocks.length) return;

  const CARET =
    '<svg class="cc-footer__acc-caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false">' +
    '<path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  blocks.forEach((block) => {
    const heading = block.querySelector('.footer-block__heading');
    const list = block.querySelector('ul.footer-block__details-content');
    if (!heading || !list) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cc-footer__acc-btn';
    btn.setAttribute('aria-expanded', 'false');
    while (heading.firstChild) btn.appendChild(heading.firstChild);
    btn.insertAdjacentHTML('beforeend', CARET);
    heading.appendChild(btn);

    btn.addEventListener('click', () => {
      if (!mq.matches) return;
      const open = block.classList.toggle('cc-footer__acc--open');
      btn.setAttribute('aria-expanded', String(open));
      list.style.maxHeight = open ? list.scrollHeight + 'px' : '';
    });
  });

  const apply = () => {
    blocks.forEach((block) => {
      const btn = block.querySelector('.cc-footer__acc-btn');
      const list = block.querySelector('ul.footer-block__details-content');
      if (!btn || !list) return;
      if (!mq.matches) {
        // desktop: always open, no inline height
        block.classList.remove('cc-footer__acc--open');
        list.style.maxHeight = '';
        btn.setAttribute('aria-expanded', 'true');
      } else if (!block.classList.contains('cc-footer__acc--open')) {
        btn.setAttribute('aria-expanded', 'false');
        list.style.maxHeight = '';
      }
    });
  };
  mq.addEventListener('change', apply);
  apply();
})();
